/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type CardAssignmentDtoStatus = typeof CardAssignmentDtoStatus[keyof typeof CardAssignmentDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAssignmentDtoStatus = {
  CREATED: 'CREATED',
  IN_TRANSIT: 'IN_TRANSIT',
  LOST: 'LOST',
  RECEIVED: 'RECEIVED',
  CANCELLED: 'CANCELLED',
} as const;
